import React, { useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
} from '@material-ui/core';
import { I18nContext } from 'translations';
import styles from 'components/Tables/style';

const extractSummary = (errorStr) => {
  if (!errorStr) return errorStr;
  const match = errorStr.match(/The following errors were found:\s*(.+?)(?:\nresolution:|$)/s);
  if (match) return match[1].trim();
  const summaryMatch = errorStr.match(/summary:\s*(.+?)(?:\nresolution:|$)/s);
  if (summaryMatch) return summaryMatch[1].replace('The following errors were found:', '').trim();
  return errorStr.trim();
};

const BulkEditErrorsTable = ({ classes, data }) => {
  const { translate } = useContext(I18nContext);

  return (
    <TableContainer>
      <Table className={classes.table} size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>{translate('app.bulkLoad.failedStops.table.row')}</TableCell>
            <TableCell>{translate('app.settings.users.form.phone')}</TableCell>
            <TableCell>{translate('error')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(data || []).map((item, index) => (
            <TableRow hover key={index} className={classes.smallData}>
              <TableCell>{item.row}</TableCell>
              <TableCell>{item.phone}</TableCell>
              <TableCell className="error">{extractSummary(item.error)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

function areEqual(prevProps, nextProps) {
  return prevProps.data === nextProps.data;
}

export default withStyles(styles)(React.memo(BulkEditErrorsTable, areEqual));
